import * as React from 'react';
import * as Yup from 'yup';
import {inject, observer} from 'mobx-react';
import {RouteComponentProps, withRouter} from 'react-router';
import {Formik, FormikProps} from 'formik';
import BaseForm, {FormValues} from './private/AirbnbLoginFormBase';
import {AirbnbAuth} from '../../models/airbnbAuthModel';

interface WithInjectedProps extends RouteComponentProps {
  airbnbAuth: AirbnbAuth;
}

@inject('airbnbAuth')
@observer
class LoginToAirbnbForm extends React.Component<RouteComponentProps, {}> {
  public render() {
    const isLoading = this._withInjectedProps.airbnbAuth.authenticating;

    return (
      <Formik
        initialValues={this._initialValues}
        validationSchema={this._validationSchema}
        onSubmit={this._handleSubmit}
        render={(props: FormikProps<FormValues>) => <BaseForm {...props} isLoading={isLoading} />}
      />
    );
  }

  private get _initialValues() {
    const {email, password} = this._withInjectedProps.airbnbAuth;
    return {email, password};
  }

  private get _validationSchema() {
    return Yup.object().shape({
      email: Yup.string()
        .email('E-mail is not valid.')
        .required('Please enter your email.'),
      password: Yup.string().required('Please enter a password.')
    });
  }

  private _handleSubmit = ({email, password}: FormValues) => {
    this._withInjectedProps.airbnbAuth.login(email, password, this._onSuccess, this._onVerificationRequired);
  };

  private _onSuccess = () => this._redirect('/connect/airbnb/choose_listings');
  private _onVerificationRequired = () => this._redirect('/connect/airbnb/verification');

  private _redirect = (url: string) => this._withInjectedProps.history.push(url);

  private get _withInjectedProps() {
    return this.props as WithInjectedProps;
  }
}

export default withRouter(LoginToAirbnbForm);



// WEBPACK FOOTER //
// ./src/containers/AirbnbLoginForm/AirbnbLoginForm.tsx